module.exports = __webpack_public_path__ + "static/media/powerzone-map.acfa4904.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/powerzone-map.png
// module id = 232
// module chunks = 0